import mixpanel from 'mixpanel-browser'

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '')

const env_check = process.env.REACT_APP_ENV === 'production'

const actions = {
  alias: (id: string) => {
    if (env_check) {
      mixpanel.alias(id)
    }
  },
  track: (name: string, props?: Record<string, string>) => {
    if (env_check) {
      mixpanel.track(name, props)
    }
  },
}

export const Mixpanel = actions
